// extracted by mini-css-extract-plugin
export default {"passwordManagerLayout":"password_passwordManagerLayout__eb5vM","passwordList":"password_passwordList__BtJCH","divider":"password_divider__CPPEw"};